<app-wizard [wizard]="wizard()"></app-wizard>
